import { put, select } from 'redux-saga/effects'

import { AdvisorAssistant } from 'services/api/entities'
import { AdvisorAssistantActionCreators } from 'app/reducers/AdvisorAssistantRedux'
import {
  advisorMetricsSelector,
  advisorSurveyCommentsSelector,
  advisorSurveyMetricsSelector,
} from 'selectors/advisorAssistant'

/**
 * Metricas de citas del asesor logueado (spec 006).
 *
 * `advisor_user_id` sale SIEMPRE del perfil en sesion, nunca de la UI: esta
 * pantalla es "mis metricas", no un explorador de asesores. Hermes no valida
 * el token en este endpoint (lee el query param tal cual), asi que el filtro
 * por asesor vive en el front hasta que el backend lo resuelva desde el JWT
 * —como ya hace en los endpoints de encuesta.
 */
export function* getMetricsRequest({ params = {} }) {
  const advisorUserId = yield select(state => state.auth.profile.userId)

  if (!advisorUserId) {
    return yield put(
      AdvisorAssistantActionCreators.getMetricsFailure({
        message: 'No hay un asesor en sesion',
      }),
    )
  }

  const response = yield AdvisorAssistant.metrics({
    startDate: params.startDate,
    endDate: params.endDate,
    advisorUserId: Number(advisorUserId),
  })

  if (response.success()) {
    return yield put(
      AdvisorAssistantActionCreators.getMetricsSuccess(
        advisorMetricsSelector(response.data),
      ),
    )
  }

  return yield put(
    AdvisorAssistantActionCreators.getMetricsFailure(response.data),
  )
}

/**
 * KPIs de la encuesta de satisfaccion (spec 010, Story 2).
 *
 * Aca NO se manda ningun id: hermes resuelve al asesor desde el token. Si el
 * token no identifica a un asesor el endpoint contesta 401/403 y se cae al
 * mismo camino de error.
 */
export function* getSurveyMetricsRequest({ params = {} }) {
  const response = yield AdvisorAssistant.surveyMetrics({
    dateFrom: params.startDate,
    dateTo: params.endDate,
  })

  if (response.success()) {
    return yield put(
      AdvisorAssistantActionCreators.getSurveyMetricsSuccess(
        advisorSurveyMetricsSelector(response.data),
      ),
    )
  }

  return yield put(
    AdvisorAssistantActionCreators.getSurveyMetricsFailure(response.data),
  )
}

/** Comentarios anonimizados del asesor (RN-010). */
export function* getSurveyCommentsRequest({ params = {} }) {
  const response = yield AdvisorAssistant.surveyComments({
    dateFrom: params.startDate,
    dateTo: params.endDate,
    page: params.page,
  })

  if (response.success()) {
    return yield put(
      AdvisorAssistantActionCreators.getSurveyCommentsSuccess(
        advisorSurveyCommentsSelector(response.data),
      ),
    )
  }

  return yield put(
    AdvisorAssistantActionCreators.getSurveyCommentsFailure(response.data),
  )
}
